import clsx from "clsx";
import { twMerge } from "tailwind-merge";
const version = "1.8.7" || "";
const versionString = version.split(".").join("_");

// This is referenced in bundled (scoped) CSS file (check: config/scoped/postcss.config.js)
export const scopingClass = ["__kalep", versionString && `__kalep_${versionString}`];
export function cx() {
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }
  return twMerge(clsx(scopingClass, classes));
}